<template>
    <div class="fade-in">
        <div
            v-for="(item, index) in experiences"
            :key="item.uuid || index"
            class="border border-light rounded mb-3 overflow-hidden"
        >
            <div class="bg-light px-3 py-2">
                <div class="pr-3">
                    <div class="d-flex justify-content-between align-items-start">
                        <h6 class="font-weight-bold mb-1">{{ item.name || '--' }}</h6>
                        <span v-if="item.isCurrent" class="badge badge-info ml-2">Current</span>
                    </div>
                    <div class="d-flex flex-column flex-sm-row justify-content-between align-items-sm-center">
                        <small class="text-muted">{{ item.company || '--' }}</small>
                        <small class="text-muted mt-1 mt-sm-0">{{ item.startDate || '--' }} - {{ item.isCurrent ? 'Present' : (item.endDate || '--') }}</small>
                    </div>
                </div>
            </div>
            <div class="p-3">
                <div class="row">
                    <div class="col-md-4 mb-3">
                        <small class="text-muted d-block">Department</small>
                        <div class="font-weight-bold">{{ item.department || '--' }}</div>
                    </div>
                    <div class="col-md-4 mb-3">
                        <small class="text-muted d-block">Location</small>
                        <div class="font-weight-bold">{{ item.location || '--' }}</div>
                    </div>
                    <div class="col-md-4 mb-3">
                        <small class="text-muted d-block">Salary</small>
                        <div class="font-weight-bold">{{ item.salary || '--' }}</div>
                    </div>
                    <div class="col-md-4 mb-3">
                        <small class="text-muted d-block">Notice Period</small>
                        <div class="font-weight-bold">{{ item.periodNoticeMonth ? `${item.periodNoticeMonth} month(s)` : '--' }}</div>
                    </div>
                    <div class="col-md-4 mb-3">
                        <small class="text-muted d-block">Years of Service</small>
                        <div class="font-weight-bold">{{ item.yearsOfService ?? '--' }}</div>
                    </div>
                    <div class="col-md-12 mb-3">
                        <small class="text-muted d-block">Address</small>
                        <div class="font-weight-bold" style="white-space: pre-line;">{{ item.address || '--' }}</div>
                    </div>
                    <div class="col-md-12 mb-3">
                        <small class="text-muted d-block">Reason For Leaving</small>
                        <div class="font-weight-bold">{{ item.reasonForLeaving || '--' }}</div>
                    </div>
                    <div class="col-md-12">
                        <small class="text-muted d-block">Service Summary</small>
                        <div>{{ item.serviceSummary || '--' }}</div>
                    </div>
                </div>
            </div>
        </div>
        <b-alert
            v-if="!experiences || experiences.length == 0"
            show
            variant="warning"
            class="text-center"
        >
            <i class="mdi mdi-alert-circle-outline"></i> {{ $t('message.noResultsFound') }}
        </b-alert>
    </div>
</template>
<script>
export default {
    props: {
        experiences: {
            type: Array,
            required: true,
        },
    },
}
</script>
